module.exports = __webpack_public_path__ + "static/media/btn_benefit_cate_sp_off.d15db978.png";